import { Licence } from 'bz-core-controls';
import { inject, observer } from 'mobx-react';
import type { ReactElement } from 'react';
import React, { Component } from 'react';
import type ServicesStore from 'tm3-core/cache/stores/services-store';

interface Props {
  children: any;
  servicesCache?: ServicesStore;
  licence?: Map<string, string>;
}

interface FilterProps {
  children: ReactElement<any> | ReactElement<any>[];
  licenceOnly?: boolean;
}

export interface IContext {
  show: boolean;
  licenced: boolean;
}

const ShowMultiDisciplineFeature = React.createContext<IContext>({ show: false, licenced: false });

class MultiDisciplineVisibilityFilter extends Component<FilterProps> {
  render() {
    const { children, licenceOnly } = this.props;
    return (
      <ShowMultiDisciplineFeature.Consumer>
        {({ show, licenced }) => {
          if (show || (licenceOnly && licenced)) {
            return children;
          }
          return null;
        }}
      </ShowMultiDisciplineFeature.Consumer>
    );
  }
}

@inject('servicesCache', 'licence')
@observer
class MultiDisciplineVisibilityContext extends Component<Props> {
  render() {
    const { children, servicesCache, licence = new Map<string, string>() } = this.props;
    const services = servicesCache!.All;
    let show = false;
    if (services.length > 1 && Boolean(licence.get('hasMultiDiscipline'))) {
      show = true;
    }

    return (
      <ShowMultiDisciplineFeature.Provider
        value={{ show, licenced: Boolean(licence.get('hasMultiDiscipline')) }}
      >
        {children}
      </ShowMultiDisciplineFeature.Provider>
    );
  }
}

export {
  MultiDisciplineVisibilityFilter,
  ShowMultiDisciplineFeature,
  MultiDisciplineVisibilityContext
};
